(function () {
  if (window.srhRecipeActionsReady === true) {
    return;
  }

  window.srhRecipeActionsReady = true;

  function getStatusElement(button) {
    var actionsRoot = button.closest('.srh-recipe-actions');
    var status = actionsRoot && actionsRoot.nextElementSibling;

    if (status && status.matches('[data-srh-recipe-share-status]')) {
      return status;
    }

    return null;
  }

  function setStatus(button, message) {
    var status = getStatusElement(button);

    if (status) {
      status.textContent = message;
    }
  }

  function copyRecipeLink(button, recipeUrl) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(recipeUrl).then(function () {
        setStatus(button, 'Recipe link copied.');
      }).catch(function () {
        setStatus(button, 'Copy this recipe link from your browser address bar.');
      });
    } else {
      setStatus(button, 'Copy this recipe link from your browser address bar.');
    }
  }

  document.addEventListener('click', function (event) {
    var printButton = event.target.closest('[data-srh-recipe-print]');

    if (printButton) {
      event.preventDefault();
      setStatus(printButton, 'Opening print dialog.');

      if (window.focus) {
        window.focus();
      }

      window.setTimeout(function () {
        window.print();
      }, 0);

      return;
    }

    var shareButton = event.target.closest('[data-srh-recipe-share]');

    if (shareButton) {
      event.preventDefault();

      var recipeTitle = shareButton.dataset.srhRecipeTitle || document.title;
      var recipeUrl = shareButton.dataset.srhRecipeUrl || window.location.href;

      if (navigator.share) {
        navigator.share({
          title: recipeTitle,
          url: recipeUrl
        }).catch(function () {
          copyRecipeLink(shareButton, recipeUrl);
        });

        return;
      }

      copyRecipeLink(shareButton, recipeUrl);
    }
  });
})();
